/* istanbul ignore file */ export function getAppGalleryPageTitle(context) {
    return context.loc('appGallery_pageTitle');
}
export function getFilteredAppPageTitle(context) {
    return context.loc('filteredApp_pageTitle');
}
export function getMyReviewsPageTitle(context) {
    return context.loc('review_pageTitle');
}
export function getFeaturedAppsTitle() {
    return 'FeaturedAppsInFilter';
}
